import React, {useEffect} from "react";
import {BodyClassNames, useResponsiveContext} from "../../../MainApp/HomeApp/ResponsiveContext";
import {useScrollContext} from "../../../MainApp/HomeApp/ScrollContext";

export const withArticleAppLayoutHOC = <AppWrapperProps, >(WrappedComponent: React.ComponentType<AppWrapperProps>) => (props: AppWrapperProps) => {

    const {modifyBodyClassName, isMobile} = useResponsiveContext();
    const {showElementsOnScroll} = useScrollContext();

    useEffect(() => {
        const wineClassConfig: BodyClassNames = {
            common: "\"body_tag body_style_wide scheme_default sidebar_hide expand_content header_style_header-1 header_position_default header_title_on menu_style_top vc_responsive events-single tribe-events-style-full tribe-events-style-theme tribe-theme-laon-wine-house page-template-page-php singular tribe-is-responsive",
            blogMode: "blog_mode_events",
            headerPosition: "header_position_default",
            headerTitle: "header_title_on",
            site: "single single-tribe_events postid-371 tribe-filter-live",
            type: "is_stream blog_style_excerpt",
            menu_style: "menu_style_top",
            topPanelFix: (showElementsOnScroll && !isMobile ? "top_panel_fixed" : "")
        }

        modifyBodyClassName(wineClassConfig);
    }, [modifyBodyClassName, isMobile, showElementsOnScroll])

    // @ts-ignore
    return <WrappedComponent {...props} />
};